import { BaseDataLayerItem } from '/@/integrations/googletagmanager/models/BaseDataLayerItem';

export class HotjarMetricEventDataLayerItem extends BaseDataLayerItem {
  /**
   * {string}
   */
  metricName;

  constructor(model = {}) {
    super(model);

    this.metricName = model.metricName;
  }
}
